export default "__VITE_ASSET__C0_ZFe55__"